<template>
  <v-container>
    <v-row class="first-row" justify="center">
      <h2>tomosibi</h2>
    </v-row>
    <v-card
      v-for="(item, index) in products"
      :key='index'
      class="mx-auto my-12"
      max-width="374"
      :href="item['link']"
    >
      <v-img
        height="250"
        :src="item['imgPath']"
      ></v-img>
      <v-card-title>{{item['title']}}</v-card-title>

      <v-card-text>
        {{item['description']}}
      </v-card-text>

      <!-- <v-divider class="mx-4"></v-divider> -->

      <v-card-text class="d-flex flex-wrap">
        <!-- <v-chip-group> -->
          <v-chip 
           v-for="(skil, index) in item['skils']"
           :key="index"
           color="amber lighten-4"
           class="chip"
          ><span class="skil">{{skil}}</span></v-chip>
        <!-- </v-chip-group> -->
      </v-card-text>
    </v-card>
  </v-container>
</template>
<style scoped>
  /* 各ページの行頭のmarginを揃える */
  .first-row{
    margin-top: 20px;
  }
  h2{
    color: white;
    text-shadow: 1px 2px 3px #808080;
  }
  .chip{
    margin-top: 4px;
    margin-right: 8px;
  }
  .skil{
    color: white;
    text-shadow: 2px 3px 4px #808080;
    font-weight: bold;
  }
</style>

<script>
  export default {
    name: 'Portfolio',
    data: () => ({
      products: [
        {
          'link': '/',
          'imgPath': '/products/myPortfolio.png',
          'title': 'My Portfolio Site',
          'description': 'Web上での活動や作品を紹介するためのサイト',
          'skils': ['Vue.js','Vuetify', 'JS', 'Lambda', 'ApiGateWay', 'CodePipeline', 'CodeBuild', 'S3', 'SNS', 'Github'],
        }
      ]
    }),
  }
</script>
